<template>
  <div class="home">
    <h1>{{ $t('home.title') }}</h1>

    <div class="row align-items-end mb-3">
      <div v-if="canCreate" class="col-auto ml-auto">
        <btn
          id="link-new-candidate"
          tag="router-link"
          type="button"
          class="btn-success"
          icon="plus"
          to="/management/new-candidate"
        >
          {{ $t('common.action.questionFormCreate.label') }}
        </btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',

  computed: {
    ...mapGetters('user', ['canCreate']),
  },
};
</script>
